import * as React from "react";
import JyloLogo from "./JyloLogo";
import { Tooltip } from "../ui/tooltip";
import { useAddInVersion } from "../../hooks/useAddInVersion";

export interface PaneHeaderProps {
  /** Whatever sits at the right: actions, then the overflow menu. */
  children?: React.ReactNode;
}

/**
 * The 48px strip at the top of every pane: the logo on the left, the actions on the
 * right, a hairline underneath and nothing else. Shared by the main layout and by the
 * sign-in gate's waiting screens, so the pane has one header rather than two that
 * drift apart.
 */
const PaneHeader = ({ children }: PaneHeaderProps) => {
  const version = useAddInVersion();

  return (
    <div className="flex h-12 flex-none flex-row items-center justify-between border-b border-border pr-2 pl-3.5">
      <Tooltip title={version ? `v${version}` : ""} side="bottom" align="start">
        {/* The tooltip needs a child that can hold a ref, hence the div. */}
        <div>
          <JyloLogo height={20} className="cursor-default" />
        </div>
      </Tooltip>
      <div className="flex min-w-0 flex-row items-center gap-0.5">{children}</div>
    </div>
  );
};

export default PaneHeader;
